import React from "react";
import { BeatLoader } from "react-spinners";

export const LoaderTwo = ({ height = 14, width = 12 }) => {
  return (
    <BeatLoader
      color='#2e3192'
      ariaLabel='three-dots-loading'
      // wrapperStyle={{ width: 80, height: 80 }}
      size={height}
      wrapperClassName=''
      visible={true}
    />
  );
};
